module.exports = "/images/b6a9761eee67998f4742175464d131ae.svg";